<template>
  <div
    component-name="txt-counter"
    class="flex flex-col gap-sm min-w-min"
    :class="{
      invisible: !finalCount,
    }"
  >
    <div
      class="overflow-hidden relative top-0 left-0 min-w-min slashed-zero tabular-nums grid grid-cols-1"
      v-surfer="{
        setup: {
          destroyOn: 'visible-fully',
        },
        observers: {
          init: true,
          visibleFully: { event: true },
          offscreenBottom: { event: true },
        },
      }"
      @surfer-visible-fully="finalCount = true"
      @surfer-offscreen-bottom="finalCount = false"
    >
      <!-- INVISIBLE PLACEHOLDER -->
      <div
        class="invisible row-start-1 row-end-2 col-start-1 col-end-2 flex items-baseline text-display-hero whitespace_nowrap leading-none select-none"
      >
        <div v-if="useMathSymbol" v-html="count >= 0 ? '+' : '-'"></div>
        <div v-html="placeholder"></div>
        <div v-if="usePercent">%</div>
      </div>
      <!-- end INVISIBLE PLACEHOLDER -->

      <!-- SLIDING NUMBERS -->
      <wrapper-reveal
        reveal="fade-from-down reveal-strong"
        class="row-start-1 row-end-2 col-start-1 col-end-2 z-2 top-0 left-0 w-full"
      >
        <div
          class="flex items-stretch text-display-hero whitespace_nowrap leading-none select-none w-full"
        >
          <div v-if="useMathSymbol" v-html="count >= 0 ? '+' : '-'"></div>

          <div class="overlow-y-hidden relative top-0 left-0">
            <span v-html="placeholder" class="invisible"></span>
            <span
              ref="tpl_nums"
              class="absolute top-0 left-0 inline-flex gap-sm"
              :class="{
                'flex-col-reverse': count >= 0,
                'flex-col': count < 0,
              }"
            >
              <span v-html="getCountString(0)"></span>

              <span
                v-for="index in parseInt(Math.abs(count))"
                v-html="getCountString(index)"
              ></span>
            </span>
          </div>
          <div v-if="usePercent">%</div>
        </div>
      </wrapper-reveal>
      <!-- end SLIDING NUMBERS -->
    </div>

    <wrapper-reveal reveal="fade-from-right">
      <div class="text-heading-5 select-none truncate" v-html="title"></div>
    </wrapper-reveal>
  </div>
</template>

<script setup>
const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  usePercent: {
    type: Boolean,
    required: false,
  },
  useMathSymbol: {
    type: Boolean,
    required: false,
  },
});
const tpl_nums = templateRef("tpl_nums");
const finalCount = ref();

const placeholder = computed(() => {
  const countAbs = Math.abs(props.count);
  let n;

  if (countAbs <= 9) {
    n = "00";
  } else {
    n = countAbs.toString();
    n.replace(/[0-9]/g, "0");
  }

  return n;
});

function getCountString(index) {
  return `${index < 10 ? "0" : ""}${index}`;
}

function processCount(duration) {
  gsap.fromTo(
    tpl_nums.value,
    {
      yPercent: props.count >= 0 ? -100 : 0,
      top: props.count >= 0 ? "100%" : 0,
    },
    {
      yPercent: props.count >= 0 ? 0 : -100,
      top: props.count >= 0 ? 0 : "100%",
      duration,
      ease: "circ.inOut",
    }
  );
}

watch(finalCount, (newVal, oldVal) => {
  if (newVal) {
    processCount(oldVal === false ? 2.2 : 0);
  }
});
</script>
